/**
 * White-label / deployment feature flags for the next-gen player.
 * Host apps pass flags via player config — never hardcode brand features here.
 *
 * @param {object} [flags]
 * @returns {object}
 */
export function resolveFeatureFlags(flags) {
  flags = flags || {};
  return {
    fullscreen: flags.fullscreen !== false,
    pictureInPicture: flags.pictureInPicture !== false,
    playbackSpeed: flags.playbackSpeed !== false,
    keyboardShortcuts: flags.keyboardShortcuts !== false,
    casting: !!flags.casting,
    chromecast: flags.chromecast !== false,
    airplay: flags.airplay !== false,
    castingSimulate: !!flags.castingSimulate,
    tvNavigation: !!flags.tvNavigation,
    /** Enterprise / partner policy hooks (opaque; CastingManager may read) */
    castingPolicy: flags.castingPolicy || null,
    subtitles: flags.subtitles !== false,
    audioTracks: flags.audioTracks !== false,
    chapters: !!flags.chapters,
    analytics: !!flags.analytics,
    drm: !!flags.drm,
    watchParty: !!flags.watchParty,
    skipIntro: !!flags.skipIntro,
    skipCredits: !!flags.skipCredits,
    continueWatching: !!flags.continueWatching,
    qualitySelection: flags.qualitySelection !== false,
    watermarks: !!flags.watermarks,
    theaterMode: flags.theaterMode !== false,
    theaterDefault: !!flags.theaterDefault,
    brandedLoading: !!flags.brandedLoading,
    fullscreenOnFirstPlay: !!flags.fullscreenOnFirstPlay,
    loadTimeoutMs:
      flags.loadTimeoutMs != null ? Number(flags.loadTimeoutMs) : 45000,
    skipButtons: flags.skipButtons !== false,
    skipInterval: flags.skipInterval != null ? Number(flags.skipInterval) : 10,
    seekZones: flags.seekZones !== false,
    autoHideControls: flags.autoHideControls !== false,
    controlsIdleMs: flags.controlsIdleMs != null ? Number(flags.controlsIdleMs) : 3200,
    highContrast: !!flags.highContrast,
    controlScale: flags.controlScale != null ? Number(flags.controlScale) : 1,
    /** Phase B1 — companion image+audio presentation (lab / opt-in) */
    companionPresentation: !!flags.companionPresentation,
    live: !!flags.live,
    dvr: !!flags.dvr,
    playlist: !!flags.playlist,
    channel: !!flags.channel,
    avod: !!flags.avod,
    ads: !!flags.ads,
    /** Modern Google IMA / VAST / VMAP — OFF unless explicitly set (Product approval). */
    modernImaAds: !!flags.modernImaAds,
    /** Live IMA — always require separate opt-in; default OFF. */
    liveImaAds: !!flags.liveImaAds,
  };
}

export default resolveFeatureFlags;
